import React, { useEffect } from 'react';
import { tourDetailActions, tourDetailSelectors } from '@lialo/core/lib/pages/tourDetail';
import { useDispatch, useSelector } from 'react-redux';
import TourInsight from './TourInsight';
import { Divider, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

interface Props {
  tourCode: string;
}

const Container = styled('div')(({ theme }) => ({
  backgroundColor: '#f1f1f1',
  opacity: 0.75,
  margin: theme.spacing(0, -2, -2),
  padding: theme.spacing(0, 2),
}));

/**
 * This displays the tour insight directly on the tour detail page (without modal).
 * @param props
 * @constructor
 */
export const InlineTourInsight = ({ tourCode }: Props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const tourInsight = useSelector(tourDetailSelectors.selectTourInsight);

  const prepare = React.useCallback(() => {
    if (tourCode) {
      dispatch(tourDetailActions.fetchTourInsightAsync.request(tourCode));
    }
  }, [dispatch, tourCode]);

  useEffect(() => {
    prepare();
  }, [prepare]);

  return tourInsight ? (
    <>
      <Divider sx={{ marginTop: 1.5 }} variant={'fullWidth'} id={'insights'} />
      <Typography variant={'h6'} sx={{ marginTop: 2, marginBottom: 2 }} variantMapping={{ h6: 'h2' }}>
        {t('tour_detail.insights.title')}
      </Typography>
      <Container>
        <TourInsight tourInsight={tourInsight} />
      </Container>
    </>
  ) : null;
};
